import * as React from "react";
import { FieldProps } from "formik";
import { Form, Input, InputNumber } from "antd";

const FormItem = Form.Item;

export const TextAreaField: React.FC<
  FieldProps<any> & { 
    prefix: React.ReactNode;
    label?: string;
    useNumberComponent?: boolean;
  }
> = ({
  field: { onChange, ...field },
  form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  useNumberComponent = false,
  ...props
}) => {
  const rawError = touched[field.name] && errors[field.name];
  const errorMsg =
    typeof rawError === "string"
      ? rawError
      : Array.isArray(rawError)
      ? rawError.join(", ")
      : undefined;

  const Comp: any = useNumberComponent ? InputNumber : Input.TextArea;

  return (
    <FormItem
    label={label}
    help={errorMsg}
    validateStatus={errorMsg ? "error" : undefined}>
      <Comp 
      {...field}
      {...props}
      onChange={
        useNumberComponent
          ? (newValue: any) => setFieldValue(field.name, newValue)
          : onChange
      } />
    </FormItem>
  );
};